import http from '@/services/http.js'

export default function getCollectionsByType(type) {
  return http.get(`api/private/v1/collections/${type}`)
}
